<template>
  <div class="product-box bg-skin-primary">
    <div class="flex align-items-center border-bottom">
      <div class="image">
        <img :src="image" alt="" 
        @error="$event.target.src = '/image/resource/no_hay_foto.webp'" />
      </div>
      <div class="box-info pl-3">
        <div class="text-action flex order-box">
          <div class="title text-skin-secondary">
            {{ data.name }}
          </div>
          <div class="">
            <CloseIcon
              class="cursor-pointer sm:ml-5"
              @click="deleteItem"
            ></CloseIcon>
          </div>
        </div>
        <div class="for-price flex order-box">
          <div
            class="for-this mt-3 text-skin-secondary w-9/12"
            v-html="data.description"
          ></div>
          <div class="price-course text-skin-secondary">
            $ {{ data.mounted_courses.price }} USD
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CloseIcon from "../../src/components/icons/Close.vue";
import toastr from "toastr";
import axios from 'axios'


export default {
  components: {
    CloseIcon,
  },
  data() {
    return {
      image: '',
    };
  },
  mounted(){
    if(this.data.image.includes('https://') || this.data.image.includes('http://'))
      this.image = this.data.image
    else
      this.image = '/image/resource/no_hay_foto.webp'   
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    userId() {
      return JSON.parse(localStorage.getItem("user"));
    },
  },
  methods: {
    deleteItem: function() {
      var url = "/api/v1/deleteShoppingCar";
      var token = (axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("a_t"));
      axios
        .post(url, {
          headers: {
            token,
          },
          id: this.data.id,
          user_id: this.userId.id,
        })
        .then((response) => {
          toastr.success("Item Eliminado");
          this.$emit("refresh");
        });
    },
  },
};
</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid #707070;
  padding-bottom: 30px;
  padding-top: 0px;
}

.image {
  width: 187px;
  height: 90px;
}

.price-course {
  font: normal normal 900 30px/37px Roboto;
  letter-spacing: 0px;
  opacity: 1;
}

.title {
  font: normal normal bold 16px/22px Roboto;
  letter-spacing: 0px;
  width: 60%;
}

.order-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.for-this {
  font: normal normal normal 15px/22px Roboto;
  letter-spacing: 0px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
}

.product-box {
  padding: 30px;
  padding-top: 10px;
}

.box-info {
  width: 100%;
}

@media (max-width: 1024px) {
  .title {
    font: normal normal bold 12px/13px Roboto;
    width: 100%;
  }

  .for-this {
    display: none;
  }

  .price-course {
    font: normal normal 900 17px/20px Roboto;
  }

}
</style>
